import { CloseOutlined, ErrorOutline } from "@mui/icons-material";
import { SnackbarContent, CustomContentProps, useSnackbar } from "notistack";
import { useState, useEffect, forwardRef } from "react";
import { useBackOrNavigate } from "../../../utils/navigateUtils";

/**
 * NotificationPanel
 */

interface Props extends CustomContentProps {
  resourceId: number;
  title: string;
  link?: string;
};

export const NotificationPanel = forwardRef<HTMLDivElement, Props>(
  ({
    id,
    title,
    message,
    link,
    variant,
  }: Props, ref) => {
    const { closeSnackbar } = useSnackbar();

    const [iconColor, setIconColor] = useState('');
    const [interfaceColor, setInterfaceColor] = useState('');

    const backOrNavigate = useBackOrNavigate();

    useEffect(() => {
      switch (variant) {
        case 'success':
          setIconColor('white');
          setInterfaceColor('#009C4E');
          break;

        case 'info':
          setIconColor('white');
          setInterfaceColor('#009C4E');
          break;

        case 'warning':
          setIconColor('black');
          setInterfaceColor('#ffd230');
          break;

        case 'error':
          setIconColor('white');
          setInterfaceColor('#ef4444');
          break;
      }
    }, [
      variant,
    ]);

    return (
      <SnackbarContent
        ref={ref}
        className={'flex flex-col w-[25rem] min-h-[8.15rem] pb-[1px] rounded pointer-events-auto'}
        style={{
          backgroundColor: interfaceColor,
          border: `1px solid ${interfaceColor}`,
        }}>
        <div
          className={'w-full h-[1.5rem] flex flex-row justify-end'}
          style={{ backgroundColor: interfaceColor }}>
          <span className="cursor-pointer me-[.15rem]" onClick={() => closeSnackbar(id)}>
            <CloseOutlined sx={{ color: iconColor, width: '1.2rem', height: '1.2rem' }} />
          </span>
        </div>
        <div className="w-full h-full flex flex-1 bg-light-mode-2 dark:bg-dark-mode-2 justify-center items-center rounded">
          <div className="w-full flex flex-row gap-4 p-4">
            <div>
              <div
                className={'size-[2.5rem] rounded flex justify-center items-center cursor-pointer'}
                style={{ backgroundColor: interfaceColor }}>
                <ErrorOutline htmlColor={iconColor} />
              </div>
            </div>
            <div
              className="w-full flex flex-col"
              onClick={() => {
                if (link && link.length > 0) {
                  backOrNavigate(link, { replace: true });
                  closeSnackbar(id);
                }
              }}>
              <div
                className="text-normal font-semibold text-black dark:text-white cursor-pointer">
                {title}
              </div>
              <div
                className="text-base text-gray-700 dark:text-gray-300 cursor-pointer">
                {message}
              </div>
            </div>
          </div>
        </div>
      </SnackbarContent>
    );
  }
);